module.exports = __webpack_public_path__ + "img/en-pc-s4.ea698d7b.png";